<template>
  <v-data-table
    :items="messages"
    :loading="loading"
    :headers="headers"
    :server-items-length="messages.length"
    no-data-text="Nenhuma mensagem encontrada"
    loading-text="Carregando mensagens..."
    :hide-default-header="hideHeader"
    hide-default-footer
    hover
  >
    <template v-slot:item.codigoInterno="{ item }">
      {{ item.codigoInterno | naoInformado }}
    </template>
    <template v-slot:item.mensagem="{ item }">
      <px-show-large-text single-line :large-text="item.mensagem" :truncate-value="100"/>
    </template>
    <template v-slot:item.options="{ item }">
      <div class="d-flex justify-end" v-if="showActions">
        <v-btn icon @click="onClickDelete(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </div>
    </template>
  </v-data-table>
</template>
<script>
export default {
  props: {
    messages: {
      type: Array,
      required: true,
    },
    loading: Boolean,
    showActions: {
      type: Boolean,
      default: false,
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Código',
          value: 'codigoInterno',
          sortable: false,
        },
        {
          text: 'Mensagem',
          value: 'mensagem',
          sortable: false,
        },
        {
          text: '',
          value: 'options',
          sortable: false,
        },
      ],
    };
  },
  methods: {
    onClickDelete(item) {
      this.$emit('remove', item);
    },
  },
};
</script>
<style scoped>
.v-data-table >>> tr:hover {
  background: transparent !important;
}
</style>
